import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'
import { Polygon } from 'components/polygon'
import { theme } from 'styles/theme'

import { PRIVACY_NOTICE_URL } from '../documents'

import * as S from './styles'

const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

const Privacy: FC = memo(() => (
  <S.Section $bg="medium">
    <Grid col={{ phone: 1, tablet: 12 }}>
      <Col col={{ tablet: 10, desktop: 10 }} start={{ tablet: 2, desktop: 2 }}>
        <S.Content>
          <S.Illustration aria-hidden>
            <NextImage src={`${IMAGES_PATH}/cadeado.svg`} alt="" width={520} height={744} />
          </S.Illustration>

          <S.Infos>
            <S.TitleRow>
              <S.PolygonWrapper aria-hidden>
                <Polygon
                  type="TriangleRound"
                  width={28}
                  height={36}
                  draw="fill"
                  color={theme.colors['cashme-magenta']}
                />
              </S.PolygonWrapper>

              <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
                Privacidade
              </Text>
            </S.TitleRow>

            <Text size="heading4" color="var(--colors-neutral-text-default)">
              Utilizamos as melhores práticas para o tratamento de dados pessoais, a partir de critérios e diretrizes
              internas e externas que garantem transparência e máxima segurança aos nossos clientes, em conformidade
              com a LGPD (Lei Geral de Proteção de Dados).
            </Text>

            <Text size="heading4" color="var(--colors-neutral-text-default)">
              Para saber como tratamos os dados pessoais por aqui, acesse o nosso{' '}
              <S.Highlight href={PRIVACY_NOTICE_URL} target="_blank" rel="noopener noreferrer">
                Aviso de Privacidade
              </S.Highlight>
              . Caso deseje realizar alguma solicitação relativa aos dados pessoais, entre em contato diretamente com o
              encarregado de Proteção de Dados (DPO), Caio Lima, representante da empresa VLK Advogados, pelo e-mail:{' '}
              <S.Highlight href="mailto:dpo@cashme.com.br">dpo@cashme.com.br</S.Highlight>.
            </Text>

            <Text size="heading4" color="var(--colors-neutral-text-default)">
              DPO da CashMe:
            </Text>

            <S.DpoLogo>
              <NextImage src={`${IMAGES_PATH}/dpo-cashme.webp`} alt="VLK Advogados" width={160} height={32} />
            </S.DpoLogo>
          </S.Infos>
        </S.Content>
      </Col>
    </Grid>
  </S.Section>
))

Privacy.displayName = 'Privacy'

export default Privacy
